import { render } from "./ListDataTable.vue?vue&type=template&id=1af54107&scoped=true"
import script from "./ListDataTable.vue?vue&type=script&lang=js"
export * from "./ListDataTable.vue?vue&type=script&lang=js"

import "./ListDataTable.vue?vue&type=style&index=0&id=1af54107&lang=scss&scoped=true"

import exportComponent from "/data/projects/private_futurelab/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1af54107"]])

export default __exports__